import React, { useState, useEffect, useRef } from "react";

import fondJeu from "assets/puzzles/iserba/roadSafety/passe_moi_l_agenda.svg";
import TypewriterText from "components/shared/TypeWriterText";

const GRID_SIZE = 5;

const IserbaGame3ClickPuzzle = ({ question, onAnswer }) => {
	const [gridSize, setGridSize] = useState(0);
	const [passengerText, setPassengerText] = useState(
		"Peux-tu vérifier le prochain rendez-vous ?"
	);
	const [narratorText, setNarratorText] = useState(null);
	const [bookClicked, setBookClicked] = useState(false);
	const gridRef = useRef(null);

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	const handleBookClick = () => {
		setPassengerText(null);
		setNarratorText("*Vous consultez l'agenda...*");
		setBookClicked(true);

		setTimeout(() => {
			onAnswer({
				scene_1_correct: false,
				scene_1_errors: ["consultation-agenda"],
			});
		}, 2000);
	};

	const submitAnswer = () => {
		if (!bookClicked) {
			// If user ignored the book and pressed "Continuer"
			onAnswer({
				scene_1_correct: true,
				scene_1_errors: [],
			});
		}
	};

	return (
		<div className="relative flex flex-col items-start non-selectable">
			<div
				ref={gridRef}
				onClick={handleBookClick}
				className={`relative grid grid-cols-${GRID_SIZE} grid-rows-${GRID_SIZE} gap-0 m-auto w-full aspect-square border-black border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)] bg-black`}
				style={{
					width: gridSize,
					height: gridSize,
					backgroundImage: `url(${fondJeu})`,
					backgroundSize: "cover",
				}}
			>
				{narratorText && (
					<div className="absolute top-[5%] left-8 right-8 text-sm py-2 px-4 shadow-md mb-4 text-center bg-white">
						<TypewriterText text={narratorText} />
					</div>
				)}
				{passengerText && (
					<div className="absolute bottom-[75%] right-16 text-sm py-2 px-4 shadow-md mb-4 bg-white rounded-full">
						<TypewriterText text={passengerText} />
					</div>
				)}
			</div>

			<div className="mt-4 h-24 px-4 mb-8 flex w-full justify-end items-center gap-0">
				<button
					onClick={submitAnswer}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Continuer
				</button>
			</div>
		</div>
	);
};

export default IserbaGame3ClickPuzzle;
